import { FigmaImage, PanesContainer, useNotionDatabase } from "dev";

export default function Debug() {
  const db = useNotionDatabase("8c4fe0fab8f34935930d914dbff0ae7a");

  if (!db) return null;

  const data = db.map((r) => ({
    status: r["Status"],
    substatus: r["Sub-status"],
    figma_url: r["Consumer Figma Link"],
    legacy_figma_url: r["Legacy Fulfillment Figma Link"],
  }));

  return (
    <PanesContainer
      items={data}
      renderItem={(r, index) => (
        <>
          <>
            <span>status: {r.status}</span>
            <span>substatus: {r.substatus}</span>
            <span>
              figma_url:
              <a href={r.figma_url}>{r.figma_url}</a>
            </span>
            <span>
              legacy_figma_url:
              <a href={r.legacy_figma_url}>{r.legacy_figma_url}</a>
            </span>
          </>

          <FigmaImage url={r.figma_url} fetchDelayMs={index * 100} />

          {r.legacy_figma_url && <FigmaImage url={r.legacy_figma_url} />}
        </>
      )}
    />
  );
}
